var option_default = {
  "option": "_9NzRQ",
  "user_choice": "nLAw9",
  "check": "n9DdS",
  "image": "vY7bK",
  "input": "nmz5G",
  "title": "p9Z9I",
  "centered": "ql3b4",
  "with_result": "wka8w",
  "list": "_6v2IC",
  "with_image": "_8eNL8",
  "progress": "fiMik",
  "progress_value": "g0chn",
  "label": "Jlu5x",
  "cta": "Abw-K",
  "adornment_icon": "_761TQ",
  "remove": "_84KUR",
  "removeButton": "_87edu",
  "removeButtonIcon": "C8yHl",
  "overlay": "g5g0X",
  "shown": "EMbLJ",
  "dark": "X-3Mh",
  "spinner": "B-XrQ",
  "spin": "CWDtQ"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
